module.exports = __webpack_public_path__ + "img/sold-out.813d6ab.png";